"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtCut = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtCut = function SvgBtCut(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.1829 17.0276C9.97984 17.0276 9 18.0074 9 19.2105C9 20.4136 9.97984 21.3935 11.1829 21.3935C12.3488 21.3935 13.2915 20.4757 13.3535 19.3346L14.4822 16.6679L15.6109 19.3098C15.6729 20.4633 16.6279 21.3811 17.7938 21.3811C19.0093 21.3811 19.9891 20.4012 19.9891 19.1857C19.9891 17.9702 19.0093 16.9904 17.7938 16.9904C17.0992 16.9904 16.4791 17.3129 16.0698 17.8214L15.0279 15.3656L18.2651 7.71287C18.3767 7.45241 18.2527 7.15473 17.9922 7.05551C17.7318 6.93147 17.4341 7.05551 17.3225 7.30357L14.4698 14.0633L11.5798 7.30357C11.4682 7.0431 11.1705 6.93147 10.9101 7.0431C10.6496 7.15473 10.538 7.45241 10.6496 7.71287L13.924 15.3656L12.8822 17.8462C12.4729 17.3377 11.8651 17.0276 11.1829 17.0276ZM12.3488 19.1981C12.3488 19.8431 11.8279 20.364 11.1829 20.364C10.538 20.364 10.0171 19.8431 10.0171 19.1981C10.0171 18.5532 10.538 18.0323 11.1829 18.0323C11.8155 18.0323 12.3364 18.5532 12.3488 19.1981ZM17.7938 17.995C18.4512 17.995 18.9721 18.5284 18.9721 19.1733C18.9721 19.8183 18.4388 20.3516 17.7938 20.3516C17.1488 20.3516 16.6155 19.8183 16.6155 19.1733C16.6155 18.5284 17.1364 17.995 17.7938 17.995Z",
    fill: "currentColor"
  }));
};

exports.SvgBtCut = SvgBtCut;